// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./tgr-icons.ttf?a774bc2aea7ac382155c96b952ff0fba", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "tgr-icons";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

i[class^="icon-"]:before, i[class*=" icon-"]:before {
    font-family: tgr-icons !important;
    font-style: normal;
    font-weight: normal !important;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.icon-zoom-out-map:before {
    content: "\\f101";
}
.icon-youtube:before {
    content: "\\f102";
}
.icon-woman:before {
    content: "\\f103";
}
.icon-wifi:before {
    content: "\\f104";
}
.icon-wifi-off:before {
    content: "\\f105";
}
.icon-wheelchair:before {
    content: "\\f106";
}
.icon-wheelchair-stop:before {
    content: "\\f107";
}
.icon-wheelchair-pickup:before {
    content: "\\f108";
}
.icon-whatsapp:before {
    content: "\\f109";
}
.icon-weight:before {
    content: "\\f10a";
}
.icon-weather-hail:before {
    content: "\\f10b";
}
.icon-water:before {
    content: "\\f10c";
}
.icon-water-voc:before {
    content: "\\f10d";
}
.icon-water-drop:before {
    content: "\\f10e";
}
.icon-watch:before {
    content: "\\f10f";
}
.icon-warning:before {
    content: "\\f110";
}
.icon-wallet:before {
    content: "\\f111";
}
.icon-volume-up:before {
    content: "\\f112";
}
.icon-volume-off:before {
    content: "\\f113";
}
.icon-volleyball:before {
    content: "\\f114";
}
.icon-volcano:before {
    content: "\\f115";
}
.icon-vital-signs:before {
    content: "\\f116";
}
.icon-visibility:before {
    content: "\\f117";
}
.icon-visibility-off:before {
    content: "\\f118";
}
.icon-visibility-off-filled:before {
    content: "\\f119";
}
.icon-visibility-filled:before {
    content: "\\f11a";
}
.icon-virus:before {
    content: "\\f11b";
}
.icon-vertical-align-top:before {
    content: "\\f11c";
}
.icon-verified:before {
    content: "\\f11d";
}
.icon-vape-free:before {
    content: "\\f11e";
}
.icon-vape-free-off:before {
    content: "\\f11f";
}
.icon-vaccines:before {
    content: "\\f120";
}
.icon-update:before {
    content: "\\f121";
}
.icon-unhappy:before {
    content: "\\f122";
}
.icon-twitter:before {
    content: "\\f123";
}
.icon-troubleshoot:before {
    content: "\\f124";
}
.icon-trophy:before {
    content: "\\f125";
}
.icon-trending-up:before {
    content: "\\f126";
}
.icon-trending-down:before {
    content: "\\f127";
}
.icon-travel:before {
    content: "\\f128";
}
.icon-travel-luggage-and-bags:before {
    content: "\\f129";
}
.icon-travel-explore:before {
    content: "\\f12a";
}
.icon-translate:before {
    content: "\\f12b";
}
.icon-transgender:before {
    content: "\\f12c";
}
.icon-transfer-miles:before {
    content: "\\f12d";
}
.icon-transcribe:before {
    content: "\\f12e";
}
.icon-train:before {
    content: "\\f12f";
}
.icon-traffic:before {
    content: "\\f130";
}
.icon-timer:before {
    content: "\\f131";
}
.icon-tiktok:before {
    content: "\\f132";
}
.icon-thumb-up:before {
    content: "\\f133";
}
.icon-thumb-up-filled:before {
    content: "\\f134";
}
.icon-thumb-down:before {
    content: "\\f135";
}
.icon-thumb-down-filled:before {
    content: "\\f136";
}
.icon-thermostat:before {
    content: "\\f137";
}
.icon-thermometer-minus:before {
    content: "\\f138";
}
.icon-theater:before {
    content: "\\f139";
}
.icon-syringe:before {
    content: "\\f13a";
}
.icon-sync-alt:before {
    content: "\\f13b";
}
.icon-swipe:before {
    content: "\\f13c";
}
.icon-swipe-right:before {
    content: "\\f13d";
}
.icon-swipe-left:before {
    content: "\\f13e";
}
.icon-swipe-down:before {
    content: "\\f13f";
}
.icon-swap-vert:before {
    content: "\\f140";
}
.icon-swap-driving-apps:before {
    content: "\\f141";
}
.icon-subway:before {
    content: "\\f142";
}
.icon-style:before {
    content: "\\f143";
}
.icon-storefront:before {
    content: "\\f144";
}
.icon-star:before {
    content: "\\f145";
}
.icon-star-filled:before {
    content: "\\f146";
}
.icon-spotify:before {
    content: "\\f147";
}
.icon-speed:before {
    content: "\\f148";
}
.icon-social-leaderboard:before {
    content: "\\f149";
}
.icon-soccer:before {
    content: "\\f14a";
}
.icon-snowmobile:before {
    content: "\\f14b";
}
.icon-smiles:before {
    content: "\\f14c";
}
.icon-smartphone:before {
    content: "\\f14d";
}
.icon-skull:before {
    content: "\\f14e";
}
.icon-signal-cellular-alt-3-bar:before {
    content: "\\f14f";
}
.icon-shopping-cart:before {
    content: "\\f150";
}
.icon-shield:before {
    content: "\\f151";
}
.icon-shield-warning:before {
    content: "\\f152";
}
.icon-shield-negative:before {
    content: "\\f153";
}
.icon-shield-info:before {
    content: "\\f154";
}
.icon-shield-check:before {
    content: "\\f155";
}
.icon-share:before {
    content: "\\f156";
}
.icon-settings:before {
    content: "\\f157";
}
.icon-sell:before {
    content: "\\f158";
}
.icon-search-filled:before {
    content: "\\f159";
}
.icon-school:before {
    content: "\\f15a";
}
.icon-schedule:before {
    content: "\\f15b";
}
.icon-save-document:before {
    content: "\\f15c";
}
.icon-sanitizer:before {
    content: "\\f15d";
}
.icon-sailing:before {
    content: "\\f15e";
}
.icon-room-service:before {
    content: "\\f15f";
}
.icon-robot-line:before {
    content: "\\f160";
}
.icon-restaurant:before {
    content: "\\f161";
}
.icon-remove:before {
    content: "\\f162";
}
.icon-remove-shopping-cart:before {
    content: "\\f163";
}
.icon-remove-circle:before {
    content: "\\f164";
}
.icon-refresh:before {
    content: "\\f165";
}
.icon-raven:before {
    content: "\\f166";
}
.icon-rainy:before {
    content: "\\f167";
}
.icon-qr_code_2:before {
    content: "\\f168";
}
.icon-pulse-alert:before {
    content: "\\f169";
}
.icon-pulmonology:before {
    content: "\\f16a";
}
.icon-promote:before {
    content: "\\f16b";
}
.icon-profile:before {
    content: "\\f16c";
}
.icon-profile-filled:before {
    content: "\\f16d";
}
.icon-prescriptions:before {
    content: "\\f16e";
}
.icon-pregnant-woman:before {
    content: "\\f16f";
}
.icon-potted-plant:before {
    content: "\\f170";
}
.icon-positive-circle:before {
    content: "\\f171";
}
.icon-plane-return-filled:before {
    content: "\\f172";
}
.icon-plane-departure-filled:before {
    content: "\\f173";
}
.icon-placeholder:before {
    content: "\\f174";
}
.icon-pix:before {
    content: "\\f175";
}
.icon-pill:before {
    content: "\\f176";
}
.icon-photo-camera:before {
    content: "\\f177";
}
.icon-phone-in-talk:before {
    content: "\\f178";
}
.icon-pets:before {
    content: "\\f179";
}
.icon-personal-injury:before {
    content: "\\f17a";
}
.icon-personal-bag:before {
    content: "\\f17b";
}
.icon-personal-bag-off:before {
    content: "\\f17c";
}
.icon-person-search:before {
    content: "\\f17d";
}
.icon-person-remove:before {
    content: "\\f17e";
}
.icon-person-check:before {
    content: "\\f17f";
}
.icon-person-chat-bubble:before {
    content: "\\f180";
}
.icon-person-add:before {
    content: "\\f181";
}
.icon-person-book:before {
    content: "\\f182";
}
.icon-percent:before {
    content: "\\f183";
}
.icon-partly-cloudy-day:before {
    content: "\\f184";
}
.icon-park:before {
    content: "\\f185";
}
.icon-package:before {
    content: "\\f186";
}
.icon-notifications:before {
    content: "\\f187";
}
.icon-notifications-off:before {
    content: "\\f188";
}
.icon-notes:before {
    content: "\\f189";
}
.icon-not-accessible:before {
    content: "\\f18a";
}
.icon-not-accessible-forward:before {
    content: "\\f18b";
}
.icon-no-transfer:before {
    content: "\\f18c";
}
.icon-no-sound:before {
    content: "\\f18d";
}
.icon-no-photography:before {
    content: "\\f18e";
}
.icon-no-meals:before {
    content: "\\f18f";
}
.icon-no-luggage:before {
    content: "\\f190";
}
.icon-no-crash:before {
    content: "\\f191";
}
.icon-neutral:before {
    content: "\\f192";
}
.icon-neurology:before {
    content: "\\f193";
}
.icon-negative-circle:before {
    content: "\\f194";
}
.icon-navigation:before {
    content: "\\f195";
}
.icon-multiple-stop:before {
    content: "\\f196";
}
.icon-motorsports:before {
    content: "\\f197";
}
.icon-mosque:before {
    content: "\\f198";
}
.icon-more-vertical:before {
    content: "\\f199";
}
.icon-more-time:before {
    content: "\\f19a";
}
.icon-more-horizontal:before {
    content: "\\f19b";
}
.icon-mop:before {
    content: "\\f19c";
}
.icon-monitoring:before {
    content: "\\f19d";
}
.icon-monitor:before {
    content: "\\f19e";
}
.icon-money:before {
    content: "\\f19f";
}
.icon-money-off:before {
    content: "\\f1a0";
}
.icon-mode-heat:before {
    content: "\\f1a1";
}
.icon-mode-cool:before {
    content: "\\f1a2";
}
.icon-minor-crash:before {
    content: "\\f1a3";
}
.icon-military-tech:before {
    content: "\\f1a4";
}
.icon-miles:before {
    content: "\\f1a5";
}
.icon-mic:before {
    content: "\\f1a6";
}
.icon-mic-off:before {
    content: "\\f1a7";
}
.icon-medical-mask:before {
    content: "\\f1a8";
}
.icon-match-case:before {
    content: "\\f1a9";
}
.icon-mastercard:before {
    content: "\\f1aa";
}
.icon-map:before {
    content: "\\f1ab";
}
.icon-man:before {
    content: "\\f1ac";
}
.icon-mail:before {
    content: "\\f1ad";
}
.icon-luggage:before {
    content: "\\f1ae";
}
.icon-logout:before {
    content: "\\f1af";
}
.icon-login:before {
    content: "\\f1b0";
}
.icon-lock-open:before {
    content: "\\f1b1";
}
.icon-lock-close:before {
    content: "\\f1b2";
}
.icon-lock-clock:before {
    content: "\\f1b3";
}
.icon-location-on:before {
    content: "\\f1b4";
}
.icon-location-off:before {
    content: "\\f1b5";
}
.icon-local-taxi:before {
    content: "\\f1b6";
}
.icon-local-shipping:before {
    content: "\\f1b7";
}
.icon-local-florist:before {
    content: "\\f1b8";
}
.icon-local-convenience-store:before {
    content: "\\f1b9";
}
.icon-local-car-wash:before {
    content: "\\f1ba";
}
.icon-local-bar:before {
    content: "\\f1bb";
}
.icon-linkedin:before {
    content: "\\f1bc";
}
.icon-link:before {
    content: "\\f1bd";
}
.icon-light-theme:before {
    content: "\\f1be";
}
.icon-license:before {
    content: "\\f1bf";
}
.icon-laundry:before {
    content: "\\f1c0";
}
.icon-launch-filled:before {
    content: "\\f1c1";
}
.icon-language:before {
    content: "\\f1c2";
}
.icon-kid-4:before {
    content: "\\f1c3";
}
.icon-kid-3:before {
    content: "\\f1c4";
}
.icon-kid-2:before {
    content: "\\f1c5";
}
.icon-kid-1:before {
    content: "\\f1c6";
}
.icon-keyboard:before {
    content: "\\f1c7";
}
.icon-keyboard-tab:before {
    content: "\\f1c8";
}
.icon-keyboard-return:before {
    content: "\\f1c9";
}
.icon-keyboard-off:before {
    content: "\\f1ca";
}
.icon-key:before {
    content: "\\f1cb";
}
.icon-key-off:before {
    content: "\\f1cc";
}
.icon-kayaking:before {
    content: "\\f1cd";
}
.icon-joystick:before {
    content: "\\f1ce";
}
.icon-instagram:before {
    content: "\\f1cf";
}
.icon-information-filled:before {
    content: "\\f1d0";
}
.icon-information-circle:before {
    content: "\\f1d1";
}
.icon-image:before {
    content: "\\f1d2";
}
.icon-image-gallery:before {
    content: "\\f1d3";
}
.icon-icecream:before {
    content: "\\f1d4";
}
.icon-ice-skating:before {
    content: "\\f1d5";
}
.icon-hotel:before {
    content: "\\f1d6";
}
.icon-home:before {
    content: "\\f1d7";
}
.icon-home-repair-service:before {
    content: "\\f1d8";
}
.icon-home-filled:before {
    content: "\\f1d9";
}
.icon-history:before {
    content: "\\f1da";
}
.icon-hiking:before {
    content: "\\f1db";
}
.icon-help:before {
    content: "\\f1dc";
}
.icon-helicopter:before {
    content: "\\f1dd";
}
.icon-heat:before {
    content: "\\f1de";
}
.icon-heart-check:before {
    content: "\\f1df";
}
.icon-hearing:before {
    content: "\\f1e0";
}
.icon-hearing-disabled:before {
    content: "\\f1e1";
}
.icon-healing:before {
    content: "\\f1e2";
}
.icon-headset-off-filled:before {
    content: "\\f1e3";
}
.icon-headset-mic:before {
    content: "\\f1e4";
}
.icon-headphones:before {
    content: "\\f1e5";
}
.icon-happy:before {
    content: "\\f1e6";
}
.icon-hamburguer-line:before {
    content: "\\f1e7";
}
.icon-hail:before {
    content: "\\f1e8";
}
.icon-groups:before {
    content: "\\f1e9";
}
.icon-group:before {
    content: "\\f1ea";
}
.icon-group-remove:before {
    content: "\\f1eb";
}
.icon-group-add:before {
    content: "\\f1ec";
}
.icon-grid-view:before {
    content: "\\f1ed";
}
.icon-good:before {
    content: "\\f1ee";
}
.icon-golf:before {
    content: "\\f1ef";
}
.icon-globe:before {
    content: "\\f1f0";
}
.icon-gift:before {
    content: "\\f1f1";
}
.icon-fork-right:before {
    content: "\\f1f2";
}
.icon-forest:before {
    content: "\\f1f3";
}
.icon-footprint:before {
    content: "\\f1f4";
}
.icon-flip-camera-ios:before {
    content: "\\f1f5";
}
.icon-flights-and-hotels:before {
    content: "\\f1f6";
}
.icon-flight_takeoff:before {
    content: "\\f1f7";
}
.icon-flight_land:before {
    content: "\\f1f8";
}
.icon-flight:before {
    content: "\\f1f9";
}
.icon-flight-class:before {
    content: "\\f1fa";
}
.icon-flag:before {
    content: "\\f1fb";
}
.icon-fire-truck:before {
    content: "\\f1fc";
}
.icon-fingerprint:before {
    content: "\\f1fd";
}
.icon-finance-mode:before {
    content: "\\f1fe";
}
.icon-filter:before {
    content: "\\f1ff";
}
.icon-filter-list:before {
    content: "\\f200";
}
.icon-festival:before {
    content: "\\f201";
}
.icon-femur-alt:before {
    content: "\\f202";
}
.icon-favorite:before {
    content: "\\f203";
}
.icon-favorite-filled:before {
    content: "\\f204";
}
.icon-fastfood:before {
    content: "\\f205";
}
.icon-family-3-people:before {
    content: "\\f206";
}
.icon-family-2-people:before {
    content: "\\f207";
}
.icon-falling:before {
    content: "\\f208";
}
.icon-factory:before {
    content: "\\f209";
}
.icon-facebook:before {
    content: "\\f20a";
}
.icon-face-id:before {
    content: "\\f20b";
}
.icon-extend-miles:before {
    content: "\\f20c";
}
.icon-explore:before {
    content: "\\f20d";
}
.icon-expand-more:before {
    content: "\\f20e";
}
.icon-expand-less:before {
    content: "\\f20f";
}
.icon-expand-all:before {
    content: "\\f210";
}
.icon-exercise:before {
    content: "\\f211";
}
.icon-event-repeat:before {
    content: "\\f212";
}
.icon-environment:before {
    content: "\\f213";
}
.icon-encrypted:before {
    content: "\\f214";
}
.icon-emergency-share:before {
    content: "\\f215";
}
.icon-emergency-home:before {
    content: "\\f216";
}
.icon-emergency-heat:before {
    content: "\\f217";
}
.icon-elevation:before {
    content: "\\f218";
}
.icon-electrical-services:before {
    content: "\\f219";
}
.icon-elderly:before {
    content: "\\f21a";
}
.icon-edit:before {
    content: "\\f21b";
}
.icon-edit-document:before {
    content: "\\f21c";
}
.icon-edit-calendar:before {
    content: "\\f21d";
}
.icon-eco:before {
    content: "\\f21e";
}
.icon-ecg:before {
    content: "\\f21f";
}
.icon-earthquake:before {
    content: "\\f220";
}
.icon-e911-emergency:before {
    content: "\\f221";
}
.icon-dry-cleaning:before {
    content: "\\f222";
}
.icon-draft:before {
    content: "\\f223";
}
.icon-download:before {
    content: "\\f224";
}
.icon-downhill-skiing:before {
    content: "\\f225";
}
.icon-doorbell-chime:before {
    content: "\\f226";
}
.icon-door-open:before {
    content: "\\f227";
}
.icon-done:before {
    content: "\\f228";
}
.icon-dns:before {
    content: "\\f229";
}
.icon-dishwasher:before {
    content: "\\f22a";
}
.icon-directions:before {
    content: "\\f22b";
}
.icon-directions-walk:before {
    content: "\\f22c";
}
.icon-directions-run:before {
    content: "\\f22d";
}
.icon-directions-car:before {
    content: "\\f22e";
}
.icon-directions-alt:before {
    content: "\\f22f";
}
.icon-directions-alt-off:before {
    content: "\\f230";
}
.icon-dining:before {
    content: "\\f231";
}
.icon-diagnosis:before {
    content: "\\f232";
}
.icon-devices:before {
    content: "\\f233";
}
.icon-devices-other:before {
    content: "\\f234";
}
.icon-devices-off:before {
    content: "\\f235";
}
.icon-device-thermostat:before {
    content: "\\f236";
}
.icon-detector-smoke:before {
    content: "\\f237";
}
.icon-detector-co:before {
    content: "\\f238";
}
.icon-detection-and-zone:before {
    content: "\\f239";
}
.icon-description:before {
    content: "\\f23a";
}
.icon-departure-board:before {
    content: "\\f23b";
}
.icon-dentistry:before {
    content: "\\f23c";
}
.icon-delete:before {
    content: "\\f23d";
}
.icon-data-table:before {
    content: "\\f23e";
}
.icon-dashboard:before {
    content: "\\f23f";
}
.icon-dashboard-customize:before {
    content: "\\f240";
}
.icon-dark-theme:before {
    content: "\\f241";
}
.icon-currency-yuan:before {
    content: "\\f242";
}
.icon-currency-yen:before {
    content: "\\f243";
}
.icon-currency-rupe:before {
    content: "\\f244";
}
.icon-currency-ruble:before {
    content: "\\f245";
}
.icon-currency-pound:before {
    content: "\\f246";
}
.icon-currency-lyre:before {
    content: "\\f247";
}
.icon-currency-franc:before {
    content: "\\f248";
}
.icon-currency-exchange:before {
    content: "\\f249";
}
.icon-currency-euro:before {
    content: "\\f24a";
}
.icon-currency-bitcoin:before {
    content: "\\f24b";
}
.icon-crowdsource:before {
    content: "\\f24c";
}
.icon-crop:before {
    content: "\\f24d";
}
.icon-credit-card:before {
    content: "\\f24e";
}
.icon-credit-card-off:before {
    content: "\\f24f";
}
.icon-credit-card-check:before {
    content: "\\f250";
}
.icon-cool-to-dry:before {
    content: "\\f251";
}
.icon-cookies-on:before {
    content: "\\f252";
}
.icon-cookies-off:before {
    content: "\\f253";
}
.icon-contract:before {
    content: "\\f254";
}
.icon-contract-delete:before {
    content: "\\f255";
}
.icon-content-copy:before {
    content: "\\f256";
}
.icon-content-copy-filled:before {
    content: "\\f257";
}
.icon-contacts:before {
    content: "\\f258";
}
.icon-construction:before {
    content: "\\f259";
}
.icon-connecting-airports-filled:before {
    content: "\\f25a";
}
.icon-confirmation-number:before {
    content: "\\f25b";
}
.icon-concierge:before {
    content: "\\f25c";
}
.icon-compare-arrows:before {
    content: "\\f25d";
}
.icon-comments-disabled:before {
    content: "\\f25e";
}
.icon-comment:before {
    content: "\\f25f";
}
.icon-cognition:before {
    content: "\\f260";
}
.icon-coffee:before {
    content: "\\f261";
}
.icon-cloud:before {
    content: "\\f262";
}
.icon-cloud-snow:before {
    content: "\\f263";
}
.icon-cloud-off:before {
    content: "\\f264";
}
.icon-close:before {
    content: "\\f265";
}
.icon-clock-loader-90:before {
    content: "\\f266";
}
.icon-clock-loader-50:before {
    content: "\\f267";
}
.icon-clock-loader-20:before {
    content: "\\f268";
}
.icon-clinical-notes:before {
    content: "\\f269";
}
.icon-clean-hands:before {
    content: "\\f26a";
}
.icon-church:before {
    content: "\\f26b";
}
.icon-child-friendly:before {
    content: "\\f26c";
}
.icon-check-all:before {
    content: "\\f26d";
}
.icon-cell-tower:before {
    content: "\\f26e";
}
.icon-celebration:before {
    content: "\\f26f";
}
.icon-category:before {
    content: "\\f270";
}
.icon-cases:before {
    content: "\\f271";
}
.icon-cardiology:before {
    content: "\\f272";
}
.icon-car-repair:before {
    content: "\\f273";
}
.icon-car-crash:before {
    content: "\\f274";
}
.icon-cancel:before {
    content: "\\f275";
}
.icon-call:before {
    content: "\\f276";
}
.icon-calendar-today:before {
    content: "\\f277";
}
.icon-calendar-clock:before {
    content: "\\f278";
}
.icon-calendar-add:before {
    content: "\\f279";
}
.icon-cake:before {
    content: "\\f27a";
}
.icon-bus-alert:before {
    content: "\\f27b";
}
.icon-bug:before {
    content: "\\f27c";
}
.icon-bubbles:before {
    content: "\\f27d";
}
.icon-bookmark:before {
    content: "\\f27e";
}
.icon-bookmark-filled:before {
    content: "\\f27f";
}
.icon-bookmark-add:before {
    content: "\\f280";
}
.icon-book:before {
    content: "\\f281";
}
.icon-book-dictionary:before {
    content: "\\f282";
}
.icon-bolt:before {
    content: "\\f283";
}
.icon-boat:before {
    content: "\\f284";
}
.icon-bluetooth:before {
    content: "\\f285";
}
.icon-bluetooth-off:before {
    content: "\\f286";
}
.icon-block:before {
    content: "\\f287";
}
.icon-blind:before {
    content: "\\f288";
}
.icon-bed:before {
    content: "\\f289";
}
.icon-beach-access:before {
    content: "\\f28a";
}
.icon-basketball:before {
    content: "\\f28b";
}
.icon-barcode:before {
    content: "\\f28c";
}
.icon-barcode-scanner:before {
    content: "\\f28d";
}
.icon-bar-chart:before {
    content: "\\f28e";
}
.icon-badge_info:before {
    content: "\\f28f";
}
.icon-bad:before {
    content: "\\f290";
}
.icon-backup:before {
    content: "\\f291";
}
.icon-backspace:before {
    content: "\\f292";
}
.icon-attribution:before {
    content: "\\f293";
}
.icon-attach-file:before {
    content: "\\f294";
}
.icon-assist-walker:before {
    content: "\\f295";
}
.icon-assignment:before {
    content: "\\f296";
}
.icon-arrow-start:before {
    content: "\\f297";
}
.icon-arrow-outward:before {
    content: "\\f298";
}
.icon-arrow-insert:before {
    content: "\\f299";
}
.icon-arrow-foward:before {
    content: "\\f29a";
}
.icon-arrow-end:before {
    content: "\\f29b";
}
.icon-arrow-chevron-right:before {
    content: "\\f29c";
}
.icon-arrow-chevron-left:before {
    content: "\\f29d";
}
.icon-arrow-back:before {
    content: "\\f29e";
}
.icon-altitude:before {
    content: "\\f29f";
}
.icon-allergy:before {
    content: "\\f2a0";
}
.icon-alarm:before {
    content: "\\f2a1";
}
.icon-airware:before {
    content: "\\f2a2";
}
.icon-airport-shuttle:before {
    content: "\\f2a3";
}
.icon-airplanemode-inactive:before {
    content: "\\f2a4";
}
.icon-airplane-ticket:before {
    content: "\\f2a5";
}
.icon-airline_stops:before {
    content: "\\f2a6";
}
.icon-airline-seat-recline-normal:before {
    content: "\\f2a7";
}
.icon-airline-seat-recline-extra:before {
    content: "\\f2a8";
}
.icon-airline-seat-legroom-normal:before {
    content: "\\f2a9";
}
.icon-air:before {
    content: "\\f2aa";
}
.icon-add:before {
    content: "\\f2ab";
}
.icon-add-shopping-cart:before {
    content: "\\f2ac";
}
.icon-add-miles:before {
    content: "\\f2ad";
}
.icon-add-circle:before {
    content: "\\f2ae";
}
.icon-add-card:before {
    content: "\\f2af";
}
.icon-activate-miles:before {
    content: "\\f2b0";
}
.icon-accesibility:before {
    content: "\\f2b1";
}
.icon-360-rotation:before {
    content: "\\f2b2";
}
`, "",{"version":3,"sources":["webpack://./node_modules/@gol-smiles/tangerina-assets/dist/icons/tgr-icons.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,+DAA+E;AACnF;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,8BAA8B;IAC9B,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB","sourcesContent":["@font-face {\n    font-family: \"tgr-icons\";\n    src: url(\"./tgr-icons.ttf?a774bc2aea7ac382155c96b952ff0fba\") format(\"truetype\");\n}\n\ni[class^=\"icon-\"]:before, i[class*=\" icon-\"]:before {\n    font-family: tgr-icons !important;\n    font-style: normal;\n    font-weight: normal !important;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-zoom-out-map:before {\n    content: \"\\f101\";\n}\n.icon-youtube:before {\n    content: \"\\f102\";\n}\n.icon-woman:before {\n    content: \"\\f103\";\n}\n.icon-wifi:before {\n    content: \"\\f104\";\n}\n.icon-wifi-off:before {\n    content: \"\\f105\";\n}\n.icon-wheelchair:before {\n    content: \"\\f106\";\n}\n.icon-wheelchair-stop:before {\n    content: \"\\f107\";\n}\n.icon-wheelchair-pickup:before {\n    content: \"\\f108\";\n}\n.icon-whatsapp:before {\n    content: \"\\f109\";\n}\n.icon-weight:before {\n    content: \"\\f10a\";\n}\n.icon-weather-hail:before {\n    content: \"\\f10b\";\n}\n.icon-water:before {\n    content: \"\\f10c\";\n}\n.icon-water-voc:before {\n    content: \"\\f10d\";\n}\n.icon-water-drop:before {\n    content: \"\\f10e\";\n}\n.icon-watch:before {\n    content: \"\\f10f\";\n}\n.icon-warning:before {\n    content: \"\\f110\";\n}\n.icon-wallet:before {\n    content: \"\\f111\";\n}\n.icon-volume-up:before {\n    content: \"\\f112\";\n}\n.icon-volume-off:before {\n    content: \"\\f113\";\n}\n.icon-volleyball:before {\n    content: \"\\f114\";\n}\n.icon-volcano:before {\n    content: \"\\f115\";\n}\n.icon-vital-signs:before {\n    content: \"\\f116\";\n}\n.icon-visibility:before {\n    content: \"\\f117\";\n}\n.icon-visibility-off:before {\n    content: \"\\f118\";\n}\n.icon-visibility-off-filled:before {\n    content: \"\\f119\";\n}\n.icon-visibility-filled:before {\n    content: \"\\f11a\";\n}\n.icon-virus:before {\n    content: \"\\f11b\";\n}\n.icon-vertical-align-top:before {\n    content: \"\\f11c\";\n}\n.icon-verified:before {\n    content: \"\\f11d\";\n}\n.icon-vape-free:before {\n    content: \"\\f11e\";\n}\n.icon-vape-free-off:before {\n    content: \"\\f11f\";\n}\n.icon-vaccines:before {\n    content: \"\\f120\";\n}\n.icon-update:before {\n    content: \"\\f121\";\n}\n.icon-unhappy:before {\n    content: \"\\f122\";\n}\n.icon-twitter:before {\n    content: \"\\f123\";\n}\n.icon-troubleshoot:before {\n    content: \"\\f124\";\n}\n.icon-trophy:before {\n    content: \"\\f125\";\n}\n.icon-trending-up:before {\n    content: \"\\f126\";\n}\n.icon-trending-down:before {\n    content: \"\\f127\";\n}\n.icon-travel:before {\n    content: \"\\f128\";\n}\n.icon-travel-luggage-and-bags:before {\n    content: \"\\f129\";\n}\n.icon-travel-explore:before {\n    content: \"\\f12a\";\n}\n.icon-translate:before {\n    content: \"\\f12b\";\n}\n.icon-transgender:before {\n    content: \"\\f12c\";\n}\n.icon-transfer-miles:before {\n    content: \"\\f12d\";\n}\n.icon-transcribe:before {\n    content: \"\\f12e\";\n}\n.icon-train:before {\n    content: \"\\f12f\";\n}\n.icon-traffic:before {\n    content: \"\\f130\";\n}\n.icon-timer:before {\n    content: \"\\f131\";\n}\n.icon-tiktok:before {\n    content: \"\\f132\";\n}\n.icon-thumb-up:before {\n    content: \"\\f133\";\n}\n.icon-thumb-up-filled:before {\n    content: \"\\f134\";\n}\n.icon-thumb-down:before {\n    content: \"\\f135\";\n}\n.icon-thumb-down-filled:before {\n    content: \"\\f136\";\n}\n.icon-thermostat:before {\n    content: \"\\f137\";\n}\n.icon-thermometer-minus:before {\n    content: \"\\f138\";\n}\n.icon-theater:before {\n    content: \"\\f139\";\n}\n.icon-syringe:before {\n    content: \"\\f13a\";\n}\n.icon-sync-alt:before {\n    content: \"\\f13b\";\n}\n.icon-swipe:before {\n    content: \"\\f13c\";\n}\n.icon-swipe-right:before {\n    content: \"\\f13d\";\n}\n.icon-swipe-left:before {\n    content: \"\\f13e\";\n}\n.icon-swipe-down:before {\n    content: \"\\f13f\";\n}\n.icon-swap-vert:before {\n    content: \"\\f140\";\n}\n.icon-swap-driving-apps:before {\n    content: \"\\f141\";\n}\n.icon-subway:before {\n    content: \"\\f142\";\n}\n.icon-style:before {\n    content: \"\\f143\";\n}\n.icon-storefront:before {\n    content: \"\\f144\";\n}\n.icon-star:before {\n    content: \"\\f145\";\n}\n.icon-star-filled:before {\n    content: \"\\f146\";\n}\n.icon-spotify:before {\n    content: \"\\f147\";\n}\n.icon-speed:before {\n    content: \"\\f148\";\n}\n.icon-social-leaderboard:before {\n    content: \"\\f149\";\n}\n.icon-soccer:before {\n    content: \"\\f14a\";\n}\n.icon-snowmobile:before {\n    content: \"\\f14b\";\n}\n.icon-smiles:before {\n    content: \"\\f14c\";\n}\n.icon-smartphone:before {\n    content: \"\\f14d\";\n}\n.icon-skull:before {\n    content: \"\\f14e\";\n}\n.icon-signal-cellular-alt-3-bar:before {\n    content: \"\\f14f\";\n}\n.icon-shopping-cart:before {\n    content: \"\\f150\";\n}\n.icon-shield:before {\n    content: \"\\f151\";\n}\n.icon-shield-warning:before {\n    content: \"\\f152\";\n}\n.icon-shield-negative:before {\n    content: \"\\f153\";\n}\n.icon-shield-info:before {\n    content: \"\\f154\";\n}\n.icon-shield-check:before {\n    content: \"\\f155\";\n}\n.icon-share:before {\n    content: \"\\f156\";\n}\n.icon-settings:before {\n    content: \"\\f157\";\n}\n.icon-sell:before {\n    content: \"\\f158\";\n}\n.icon-search-filled:before {\n    content: \"\\f159\";\n}\n.icon-school:before {\n    content: \"\\f15a\";\n}\n.icon-schedule:before {\n    content: \"\\f15b\";\n}\n.icon-save-document:before {\n    content: \"\\f15c\";\n}\n.icon-sanitizer:before {\n    content: \"\\f15d\";\n}\n.icon-sailing:before {\n    content: \"\\f15e\";\n}\n.icon-room-service:before {\n    content: \"\\f15f\";\n}\n.icon-robot-line:before {\n    content: \"\\f160\";\n}\n.icon-restaurant:before {\n    content: \"\\f161\";\n}\n.icon-remove:before {\n    content: \"\\f162\";\n}\n.icon-remove-shopping-cart:before {\n    content: \"\\f163\";\n}\n.icon-remove-circle:before {\n    content: \"\\f164\";\n}\n.icon-refresh:before {\n    content: \"\\f165\";\n}\n.icon-raven:before {\n    content: \"\\f166\";\n}\n.icon-rainy:before {\n    content: \"\\f167\";\n}\n.icon-qr_code_2:before {\n    content: \"\\f168\";\n}\n.icon-pulse-alert:before {\n    content: \"\\f169\";\n}\n.icon-pulmonology:before {\n    content: \"\\f16a\";\n}\n.icon-promote:before {\n    content: \"\\f16b\";\n}\n.icon-profile:before {\n    content: \"\\f16c\";\n}\n.icon-profile-filled:before {\n    content: \"\\f16d\";\n}\n.icon-prescriptions:before {\n    content: \"\\f16e\";\n}\n.icon-pregnant-woman:before {\n    content: \"\\f16f\";\n}\n.icon-potted-plant:before {\n    content: \"\\f170\";\n}\n.icon-positive-circle:before {\n    content: \"\\f171\";\n}\n.icon-plane-return-filled:before {\n    content: \"\\f172\";\n}\n.icon-plane-departure-filled:before {\n    content: \"\\f173\";\n}\n.icon-placeholder:before {\n    content: \"\\f174\";\n}\n.icon-pix:before {\n    content: \"\\f175\";\n}\n.icon-pill:before {\n    content: \"\\f176\";\n}\n.icon-photo-camera:before {\n    content: \"\\f177\";\n}\n.icon-phone-in-talk:before {\n    content: \"\\f178\";\n}\n.icon-pets:before {\n    content: \"\\f179\";\n}\n.icon-personal-injury:before {\n    content: \"\\f17a\";\n}\n.icon-personal-bag:before {\n    content: \"\\f17b\";\n}\n.icon-personal-bag-off:before {\n    content: \"\\f17c\";\n}\n.icon-person-search:before {\n    content: \"\\f17d\";\n}\n.icon-person-remove:before {\n    content: \"\\f17e\";\n}\n.icon-person-check:before {\n    content: \"\\f17f\";\n}\n.icon-person-chat-bubble:before {\n    content: \"\\f180\";\n}\n.icon-person-add:before {\n    content: \"\\f181\";\n}\n.icon-person-book:before {\n    content: \"\\f182\";\n}\n.icon-percent:before {\n    content: \"\\f183\";\n}\n.icon-partly-cloudy-day:before {\n    content: \"\\f184\";\n}\n.icon-park:before {\n    content: \"\\f185\";\n}\n.icon-package:before {\n    content: \"\\f186\";\n}\n.icon-notifications:before {\n    content: \"\\f187\";\n}\n.icon-notifications-off:before {\n    content: \"\\f188\";\n}\n.icon-notes:before {\n    content: \"\\f189\";\n}\n.icon-not-accessible:before {\n    content: \"\\f18a\";\n}\n.icon-not-accessible-forward:before {\n    content: \"\\f18b\";\n}\n.icon-no-transfer:before {\n    content: \"\\f18c\";\n}\n.icon-no-sound:before {\n    content: \"\\f18d\";\n}\n.icon-no-photography:before {\n    content: \"\\f18e\";\n}\n.icon-no-meals:before {\n    content: \"\\f18f\";\n}\n.icon-no-luggage:before {\n    content: \"\\f190\";\n}\n.icon-no-crash:before {\n    content: \"\\f191\";\n}\n.icon-neutral:before {\n    content: \"\\f192\";\n}\n.icon-neurology:before {\n    content: \"\\f193\";\n}\n.icon-negative-circle:before {\n    content: \"\\f194\";\n}\n.icon-navigation:before {\n    content: \"\\f195\";\n}\n.icon-multiple-stop:before {\n    content: \"\\f196\";\n}\n.icon-motorsports:before {\n    content: \"\\f197\";\n}\n.icon-mosque:before {\n    content: \"\\f198\";\n}\n.icon-more-vertical:before {\n    content: \"\\f199\";\n}\n.icon-more-time:before {\n    content: \"\\f19a\";\n}\n.icon-more-horizontal:before {\n    content: \"\\f19b\";\n}\n.icon-mop:before {\n    content: \"\\f19c\";\n}\n.icon-monitoring:before {\n    content: \"\\f19d\";\n}\n.icon-monitor:before {\n    content: \"\\f19e\";\n}\n.icon-money:before {\n    content: \"\\f19f\";\n}\n.icon-money-off:before {\n    content: \"\\f1a0\";\n}\n.icon-mode-heat:before {\n    content: \"\\f1a1\";\n}\n.icon-mode-cool:before {\n    content: \"\\f1a2\";\n}\n.icon-minor-crash:before {\n    content: \"\\f1a3\";\n}\n.icon-military-tech:before {\n    content: \"\\f1a4\";\n}\n.icon-miles:before {\n    content: \"\\f1a5\";\n}\n.icon-mic:before {\n    content: \"\\f1a6\";\n}\n.icon-mic-off:before {\n    content: \"\\f1a7\";\n}\n.icon-medical-mask:before {\n    content: \"\\f1a8\";\n}\n.icon-match-case:before {\n    content: \"\\f1a9\";\n}\n.icon-mastercard:before {\n    content: \"\\f1aa\";\n}\n.icon-map:before {\n    content: \"\\f1ab\";\n}\n.icon-man:before {\n    content: \"\\f1ac\";\n}\n.icon-mail:before {\n    content: \"\\f1ad\";\n}\n.icon-luggage:before {\n    content: \"\\f1ae\";\n}\n.icon-logout:before {\n    content: \"\\f1af\";\n}\n.icon-login:before {\n    content: \"\\f1b0\";\n}\n.icon-lock-open:before {\n    content: \"\\f1b1\";\n}\n.icon-lock-close:before {\n    content: \"\\f1b2\";\n}\n.icon-lock-clock:before {\n    content: \"\\f1b3\";\n}\n.icon-location-on:before {\n    content: \"\\f1b4\";\n}\n.icon-location-off:before {\n    content: \"\\f1b5\";\n}\n.icon-local-taxi:before {\n    content: \"\\f1b6\";\n}\n.icon-local-shipping:before {\n    content: \"\\f1b7\";\n}\n.icon-local-florist:before {\n    content: \"\\f1b8\";\n}\n.icon-local-convenience-store:before {\n    content: \"\\f1b9\";\n}\n.icon-local-car-wash:before {\n    content: \"\\f1ba\";\n}\n.icon-local-bar:before {\n    content: \"\\f1bb\";\n}\n.icon-linkedin:before {\n    content: \"\\f1bc\";\n}\n.icon-link:before {\n    content: \"\\f1bd\";\n}\n.icon-light-theme:before {\n    content: \"\\f1be\";\n}\n.icon-license:before {\n    content: \"\\f1bf\";\n}\n.icon-laundry:before {\n    content: \"\\f1c0\";\n}\n.icon-launch-filled:before {\n    content: \"\\f1c1\";\n}\n.icon-language:before {\n    content: \"\\f1c2\";\n}\n.icon-kid-4:before {\n    content: \"\\f1c3\";\n}\n.icon-kid-3:before {\n    content: \"\\f1c4\";\n}\n.icon-kid-2:before {\n    content: \"\\f1c5\";\n}\n.icon-kid-1:before {\n    content: \"\\f1c6\";\n}\n.icon-keyboard:before {\n    content: \"\\f1c7\";\n}\n.icon-keyboard-tab:before {\n    content: \"\\f1c8\";\n}\n.icon-keyboard-return:before {\n    content: \"\\f1c9\";\n}\n.icon-keyboard-off:before {\n    content: \"\\f1ca\";\n}\n.icon-key:before {\n    content: \"\\f1cb\";\n}\n.icon-key-off:before {\n    content: \"\\f1cc\";\n}\n.icon-kayaking:before {\n    content: \"\\f1cd\";\n}\n.icon-joystick:before {\n    content: \"\\f1ce\";\n}\n.icon-instagram:before {\n    content: \"\\f1cf\";\n}\n.icon-information-filled:before {\n    content: \"\\f1d0\";\n}\n.icon-information-circle:before {\n    content: \"\\f1d1\";\n}\n.icon-image:before {\n    content: \"\\f1d2\";\n}\n.icon-image-gallery:before {\n    content: \"\\f1d3\";\n}\n.icon-icecream:before {\n    content: \"\\f1d4\";\n}\n.icon-ice-skating:before {\n    content: \"\\f1d5\";\n}\n.icon-hotel:before {\n    content: \"\\f1d6\";\n}\n.icon-home:before {\n    content: \"\\f1d7\";\n}\n.icon-home-repair-service:before {\n    content: \"\\f1d8\";\n}\n.icon-home-filled:before {\n    content: \"\\f1d9\";\n}\n.icon-history:before {\n    content: \"\\f1da\";\n}\n.icon-hiking:before {\n    content: \"\\f1db\";\n}\n.icon-help:before {\n    content: \"\\f1dc\";\n}\n.icon-helicopter:before {\n    content: \"\\f1dd\";\n}\n.icon-heat:before {\n    content: \"\\f1de\";\n}\n.icon-heart-check:before {\n    content: \"\\f1df\";\n}\n.icon-hearing:before {\n    content: \"\\f1e0\";\n}\n.icon-hearing-disabled:before {\n    content: \"\\f1e1\";\n}\n.icon-healing:before {\n    content: \"\\f1e2\";\n}\n.icon-headset-off-filled:before {\n    content: \"\\f1e3\";\n}\n.icon-headset-mic:before {\n    content: \"\\f1e4\";\n}\n.icon-headphones:before {\n    content: \"\\f1e5\";\n}\n.icon-happy:before {\n    content: \"\\f1e6\";\n}\n.icon-hamburguer-line:before {\n    content: \"\\f1e7\";\n}\n.icon-hail:before {\n    content: \"\\f1e8\";\n}\n.icon-groups:before {\n    content: \"\\f1e9\";\n}\n.icon-group:before {\n    content: \"\\f1ea\";\n}\n.icon-group-remove:before {\n    content: \"\\f1eb\";\n}\n.icon-group-add:before {\n    content: \"\\f1ec\";\n}\n.icon-grid-view:before {\n    content: \"\\f1ed\";\n}\n.icon-good:before {\n    content: \"\\f1ee\";\n}\n.icon-golf:before {\n    content: \"\\f1ef\";\n}\n.icon-globe:before {\n    content: \"\\f1f0\";\n}\n.icon-gift:before {\n    content: \"\\f1f1\";\n}\n.icon-fork-right:before {\n    content: \"\\f1f2\";\n}\n.icon-forest:before {\n    content: \"\\f1f3\";\n}\n.icon-footprint:before {\n    content: \"\\f1f4\";\n}\n.icon-flip-camera-ios:before {\n    content: \"\\f1f5\";\n}\n.icon-flights-and-hotels:before {\n    content: \"\\f1f6\";\n}\n.icon-flight_takeoff:before {\n    content: \"\\f1f7\";\n}\n.icon-flight_land:before {\n    content: \"\\f1f8\";\n}\n.icon-flight:before {\n    content: \"\\f1f9\";\n}\n.icon-flight-class:before {\n    content: \"\\f1fa\";\n}\n.icon-flag:before {\n    content: \"\\f1fb\";\n}\n.icon-fire-truck:before {\n    content: \"\\f1fc\";\n}\n.icon-fingerprint:before {\n    content: \"\\f1fd\";\n}\n.icon-finance-mode:before {\n    content: \"\\f1fe\";\n}\n.icon-filter:before {\n    content: \"\\f1ff\";\n}\n.icon-filter-list:before {\n    content: \"\\f200\";\n}\n.icon-festival:before {\n    content: \"\\f201\";\n}\n.icon-femur-alt:before {\n    content: \"\\f202\";\n}\n.icon-favorite:before {\n    content: \"\\f203\";\n}\n.icon-favorite-filled:before {\n    content: \"\\f204\";\n}\n.icon-fastfood:before {\n    content: \"\\f205\";\n}\n.icon-family-3-people:before {\n    content: \"\\f206\";\n}\n.icon-family-2-people:before {\n    content: \"\\f207\";\n}\n.icon-falling:before {\n    content: \"\\f208\";\n}\n.icon-factory:before {\n    content: \"\\f209\";\n}\n.icon-facebook:before {\n    content: \"\\f20a\";\n}\n.icon-face-id:before {\n    content: \"\\f20b\";\n}\n.icon-extend-miles:before {\n    content: \"\\f20c\";\n}\n.icon-explore:before {\n    content: \"\\f20d\";\n}\n.icon-expand-more:before {\n    content: \"\\f20e\";\n}\n.icon-expand-less:before {\n    content: \"\\f20f\";\n}\n.icon-expand-all:before {\n    content: \"\\f210\";\n}\n.icon-exercise:before {\n    content: \"\\f211\";\n}\n.icon-event-repeat:before {\n    content: \"\\f212\";\n}\n.icon-environment:before {\n    content: \"\\f213\";\n}\n.icon-encrypted:before {\n    content: \"\\f214\";\n}\n.icon-emergency-share:before {\n    content: \"\\f215\";\n}\n.icon-emergency-home:before {\n    content: \"\\f216\";\n}\n.icon-emergency-heat:before {\n    content: \"\\f217\";\n}\n.icon-elevation:before {\n    content: \"\\f218\";\n}\n.icon-electrical-services:before {\n    content: \"\\f219\";\n}\n.icon-elderly:before {\n    content: \"\\f21a\";\n}\n.icon-edit:before {\n    content: \"\\f21b\";\n}\n.icon-edit-document:before {\n    content: \"\\f21c\";\n}\n.icon-edit-calendar:before {\n    content: \"\\f21d\";\n}\n.icon-eco:before {\n    content: \"\\f21e\";\n}\n.icon-ecg:before {\n    content: \"\\f21f\";\n}\n.icon-earthquake:before {\n    content: \"\\f220\";\n}\n.icon-e911-emergency:before {\n    content: \"\\f221\";\n}\n.icon-dry-cleaning:before {\n    content: \"\\f222\";\n}\n.icon-draft:before {\n    content: \"\\f223\";\n}\n.icon-download:before {\n    content: \"\\f224\";\n}\n.icon-downhill-skiing:before {\n    content: \"\\f225\";\n}\n.icon-doorbell-chime:before {\n    content: \"\\f226\";\n}\n.icon-door-open:before {\n    content: \"\\f227\";\n}\n.icon-done:before {\n    content: \"\\f228\";\n}\n.icon-dns:before {\n    content: \"\\f229\";\n}\n.icon-dishwasher:before {\n    content: \"\\f22a\";\n}\n.icon-directions:before {\n    content: \"\\f22b\";\n}\n.icon-directions-walk:before {\n    content: \"\\f22c\";\n}\n.icon-directions-run:before {\n    content: \"\\f22d\";\n}\n.icon-directions-car:before {\n    content: \"\\f22e\";\n}\n.icon-directions-alt:before {\n    content: \"\\f22f\";\n}\n.icon-directions-alt-off:before {\n    content: \"\\f230\";\n}\n.icon-dining:before {\n    content: \"\\f231\";\n}\n.icon-diagnosis:before {\n    content: \"\\f232\";\n}\n.icon-devices:before {\n    content: \"\\f233\";\n}\n.icon-devices-other:before {\n    content: \"\\f234\";\n}\n.icon-devices-off:before {\n    content: \"\\f235\";\n}\n.icon-device-thermostat:before {\n    content: \"\\f236\";\n}\n.icon-detector-smoke:before {\n    content: \"\\f237\";\n}\n.icon-detector-co:before {\n    content: \"\\f238\";\n}\n.icon-detection-and-zone:before {\n    content: \"\\f239\";\n}\n.icon-description:before {\n    content: \"\\f23a\";\n}\n.icon-departure-board:before {\n    content: \"\\f23b\";\n}\n.icon-dentistry:before {\n    content: \"\\f23c\";\n}\n.icon-delete:before {\n    content: \"\\f23d\";\n}\n.icon-data-table:before {\n    content: \"\\f23e\";\n}\n.icon-dashboard:before {\n    content: \"\\f23f\";\n}\n.icon-dashboard-customize:before {\n    content: \"\\f240\";\n}\n.icon-dark-theme:before {\n    content: \"\\f241\";\n}\n.icon-currency-yuan:before {\n    content: \"\\f242\";\n}\n.icon-currency-yen:before {\n    content: \"\\f243\";\n}\n.icon-currency-rupe:before {\n    content: \"\\f244\";\n}\n.icon-currency-ruble:before {\n    content: \"\\f245\";\n}\n.icon-currency-pound:before {\n    content: \"\\f246\";\n}\n.icon-currency-lyre:before {\n    content: \"\\f247\";\n}\n.icon-currency-franc:before {\n    content: \"\\f248\";\n}\n.icon-currency-exchange:before {\n    content: \"\\f249\";\n}\n.icon-currency-euro:before {\n    content: \"\\f24a\";\n}\n.icon-currency-bitcoin:before {\n    content: \"\\f24b\";\n}\n.icon-crowdsource:before {\n    content: \"\\f24c\";\n}\n.icon-crop:before {\n    content: \"\\f24d\";\n}\n.icon-credit-card:before {\n    content: \"\\f24e\";\n}\n.icon-credit-card-off:before {\n    content: \"\\f24f\";\n}\n.icon-credit-card-check:before {\n    content: \"\\f250\";\n}\n.icon-cool-to-dry:before {\n    content: \"\\f251\";\n}\n.icon-cookies-on:before {\n    content: \"\\f252\";\n}\n.icon-cookies-off:before {\n    content: \"\\f253\";\n}\n.icon-contract:before {\n    content: \"\\f254\";\n}\n.icon-contract-delete:before {\n    content: \"\\f255\";\n}\n.icon-content-copy:before {\n    content: \"\\f256\";\n}\n.icon-content-copy-filled:before {\n    content: \"\\f257\";\n}\n.icon-contacts:before {\n    content: \"\\f258\";\n}\n.icon-construction:before {\n    content: \"\\f259\";\n}\n.icon-connecting-airports-filled:before {\n    content: \"\\f25a\";\n}\n.icon-confirmation-number:before {\n    content: \"\\f25b\";\n}\n.icon-concierge:before {\n    content: \"\\f25c\";\n}\n.icon-compare-arrows:before {\n    content: \"\\f25d\";\n}\n.icon-comments-disabled:before {\n    content: \"\\f25e\";\n}\n.icon-comment:before {\n    content: \"\\f25f\";\n}\n.icon-cognition:before {\n    content: \"\\f260\";\n}\n.icon-coffee:before {\n    content: \"\\f261\";\n}\n.icon-cloud:before {\n    content: \"\\f262\";\n}\n.icon-cloud-snow:before {\n    content: \"\\f263\";\n}\n.icon-cloud-off:before {\n    content: \"\\f264\";\n}\n.icon-close:before {\n    content: \"\\f265\";\n}\n.icon-clock-loader-90:before {\n    content: \"\\f266\";\n}\n.icon-clock-loader-50:before {\n    content: \"\\f267\";\n}\n.icon-clock-loader-20:before {\n    content: \"\\f268\";\n}\n.icon-clinical-notes:before {\n    content: \"\\f269\";\n}\n.icon-clean-hands:before {\n    content: \"\\f26a\";\n}\n.icon-church:before {\n    content: \"\\f26b\";\n}\n.icon-child-friendly:before {\n    content: \"\\f26c\";\n}\n.icon-check-all:before {\n    content: \"\\f26d\";\n}\n.icon-cell-tower:before {\n    content: \"\\f26e\";\n}\n.icon-celebration:before {\n    content: \"\\f26f\";\n}\n.icon-category:before {\n    content: \"\\f270\";\n}\n.icon-cases:before {\n    content: \"\\f271\";\n}\n.icon-cardiology:before {\n    content: \"\\f272\";\n}\n.icon-car-repair:before {\n    content: \"\\f273\";\n}\n.icon-car-crash:before {\n    content: \"\\f274\";\n}\n.icon-cancel:before {\n    content: \"\\f275\";\n}\n.icon-call:before {\n    content: \"\\f276\";\n}\n.icon-calendar-today:before {\n    content: \"\\f277\";\n}\n.icon-calendar-clock:before {\n    content: \"\\f278\";\n}\n.icon-calendar-add:before {\n    content: \"\\f279\";\n}\n.icon-cake:before {\n    content: \"\\f27a\";\n}\n.icon-bus-alert:before {\n    content: \"\\f27b\";\n}\n.icon-bug:before {\n    content: \"\\f27c\";\n}\n.icon-bubbles:before {\n    content: \"\\f27d\";\n}\n.icon-bookmark:before {\n    content: \"\\f27e\";\n}\n.icon-bookmark-filled:before {\n    content: \"\\f27f\";\n}\n.icon-bookmark-add:before {\n    content: \"\\f280\";\n}\n.icon-book:before {\n    content: \"\\f281\";\n}\n.icon-book-dictionary:before {\n    content: \"\\f282\";\n}\n.icon-bolt:before {\n    content: \"\\f283\";\n}\n.icon-boat:before {\n    content: \"\\f284\";\n}\n.icon-bluetooth:before {\n    content: \"\\f285\";\n}\n.icon-bluetooth-off:before {\n    content: \"\\f286\";\n}\n.icon-block:before {\n    content: \"\\f287\";\n}\n.icon-blind:before {\n    content: \"\\f288\";\n}\n.icon-bed:before {\n    content: \"\\f289\";\n}\n.icon-beach-access:before {\n    content: \"\\f28a\";\n}\n.icon-basketball:before {\n    content: \"\\f28b\";\n}\n.icon-barcode:before {\n    content: \"\\f28c\";\n}\n.icon-barcode-scanner:before {\n    content: \"\\f28d\";\n}\n.icon-bar-chart:before {\n    content: \"\\f28e\";\n}\n.icon-badge_info:before {\n    content: \"\\f28f\";\n}\n.icon-bad:before {\n    content: \"\\f290\";\n}\n.icon-backup:before {\n    content: \"\\f291\";\n}\n.icon-backspace:before {\n    content: \"\\f292\";\n}\n.icon-attribution:before {\n    content: \"\\f293\";\n}\n.icon-attach-file:before {\n    content: \"\\f294\";\n}\n.icon-assist-walker:before {\n    content: \"\\f295\";\n}\n.icon-assignment:before {\n    content: \"\\f296\";\n}\n.icon-arrow-start:before {\n    content: \"\\f297\";\n}\n.icon-arrow-outward:before {\n    content: \"\\f298\";\n}\n.icon-arrow-insert:before {\n    content: \"\\f299\";\n}\n.icon-arrow-foward:before {\n    content: \"\\f29a\";\n}\n.icon-arrow-end:before {\n    content: \"\\f29b\";\n}\n.icon-arrow-chevron-right:before {\n    content: \"\\f29c\";\n}\n.icon-arrow-chevron-left:before {\n    content: \"\\f29d\";\n}\n.icon-arrow-back:before {\n    content: \"\\f29e\";\n}\n.icon-altitude:before {\n    content: \"\\f29f\";\n}\n.icon-allergy:before {\n    content: \"\\f2a0\";\n}\n.icon-alarm:before {\n    content: \"\\f2a1\";\n}\n.icon-airware:before {\n    content: \"\\f2a2\";\n}\n.icon-airport-shuttle:before {\n    content: \"\\f2a3\";\n}\n.icon-airplanemode-inactive:before {\n    content: \"\\f2a4\";\n}\n.icon-airplane-ticket:before {\n    content: \"\\f2a5\";\n}\n.icon-airline_stops:before {\n    content: \"\\f2a6\";\n}\n.icon-airline-seat-recline-normal:before {\n    content: \"\\f2a7\";\n}\n.icon-airline-seat-recline-extra:before {\n    content: \"\\f2a8\";\n}\n.icon-airline-seat-legroom-normal:before {\n    content: \"\\f2a9\";\n}\n.icon-air:before {\n    content: \"\\f2aa\";\n}\n.icon-add:before {\n    content: \"\\f2ab\";\n}\n.icon-add-shopping-cart:before {\n    content: \"\\f2ac\";\n}\n.icon-add-miles:before {\n    content: \"\\f2ad\";\n}\n.icon-add-circle:before {\n    content: \"\\f2ae\";\n}\n.icon-add-card:before {\n    content: \"\\f2af\";\n}\n.icon-activate-miles:before {\n    content: \"\\f2b0\";\n}\n.icon-accesibility:before {\n    content: \"\\f2b1\";\n}\n.icon-360-rotation:before {\n    content: \"\\f2b2\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
